(function() {
  'use strict';

  function AvalnaHeroCarousel(el) {
    this.el = el;
    this.slides = el.querySelectorAll('.avalna-hero__slide');
    this.dots = el.querySelectorAll('.avalna-hero__dot');
    this.prevBtn = el.querySelector('.avalna-hero__arrow--prev');
    this.nextBtn = el.querySelector('.avalna-hero__arrow--next');
    this.current = 0;
    this.total = this.slides.length;
    this.autoplayEnabled = el.dataset.avalnaHeroAutoplay === 'true';
    this.speed = (parseInt(el.dataset.avalnaHeroSpeed, 10) || 5) * 1000;
    this.timer = null;
    this.paused = false;
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    el._avalnaHeroCarousel = this;

    if (this.total <= 1) return;

    this.avalnaBindEvents();
    this.avalnaUpdateActiveScrim();

    if (this.autoplayEnabled && !this.reducedMotion.matches) {
      this.avalnaStartAutoplay();
    }
  }

  AvalnaHeroCarousel.prototype.avalnaBindEvents = function() {
    var self = this;

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', function() { self.avalnaPrev(); });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', function() { self.avalnaNext(); });
    }

    for (var i = 0; i < this.dots.length; i++) {
      (function(index) {
        self.dots[index].addEventListener('click', function() {
          self.avalnaGoTo(index);
        });
      })(i);
    }

    this.el.addEventListener('mouseenter', function() { self.paused = true; });
    this.el.addEventListener('mouseleave', function() { self.paused = false; });

    this.el.addEventListener('focusin', function() { self.paused = true; });
    this.el.addEventListener('focusout', function(e) {
      if (!self.el.contains(e.relatedTarget)) { self.paused = false; }
    });

    this.el.addEventListener('touchstart', function(e) {
      self.touchStartX = e.changedTouches[0].screenX;
      self.touchStartY = e.changedTouches[0].screenY;
    }, { passive: true });

    this.el.addEventListener('touchend', function(e) {
      var diffX = self.touchStartX - e.changedTouches[0].screenX;
      var diffY = self.touchStartY - e.changedTouches[0].screenY;
      if (Math.abs(diffX) > 50 && Math.abs(diffX) > Math.abs(diffY)) {
        if (diffX > 0) { self.avalnaNext(); } else { self.avalnaPrev(); }
      }
    }, { passive: true });

    this.reducedMotion.addEventListener('change', function(e) {
      if (e.matches) {
        self.avalnaStopAutoplay();
      } else if (self.autoplayEnabled) {
        self.avalnaStartAutoplay();
      }
    });

    this.el.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft') { self.avalnaPrev(); e.preventDefault(); }
      if (e.key === 'ArrowRight') { self.avalnaNext(); e.preventDefault(); }
    });
  };

  AvalnaHeroCarousel.prototype.avalnaGoTo = function(index) {
    if (index === this.current || index < 0 || index >= this.total) return;

    this.slides[this.current].classList.remove('avalna-hero__slide--active');
    this.slides[this.current].setAttribute('aria-hidden', 'true');

    this.current = index;

    this.slides[this.current].classList.add('avalna-hero__slide--active');
    this.slides[this.current].removeAttribute('aria-hidden');

    this.avalnaUpdateDots();
    this.avalnaUpdateActiveScrim();
    this.avalnaResetAutoplay();
  };

  AvalnaHeroCarousel.prototype.avalnaNext = function() {
    this.avalnaGoTo((this.current + 1) % this.total);
  };

  AvalnaHeroCarousel.prototype.avalnaPrev = function() {
    this.avalnaGoTo((this.current - 1 + this.total) % this.total);
  };

  AvalnaHeroCarousel.prototype.avalnaUpdateDots = function() {
    for (var i = 0; i < this.dots.length; i++) {
      var isActive = i === this.current;
      this.dots[i].classList.toggle('avalna-hero__dot--active', isActive);
      this.dots[i].setAttribute('aria-selected', isActive ? 'true' : 'false');
    }
  };

  AvalnaHeroCarousel.prototype.avalnaUpdateActiveScrim = function() {
    var scrimType = this.slides[this.current].dataset.avalnaHeroScrim || 'dark';
    this.el.dataset.avalnaHeroActiveScrim = scrimType;
  };

  AvalnaHeroCarousel.prototype.avalnaStartAutoplay = function() {
    var self = this;
    this.timer = setInterval(function() {
      if (!self.paused) { self.avalnaNext(); }
    }, this.speed);
  };

  AvalnaHeroCarousel.prototype.avalnaStopAutoplay = function() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  };

  AvalnaHeroCarousel.prototype.avalnaResetAutoplay = function() {
    if (this.autoplayEnabled && !this.reducedMotion.matches) {
      this.avalnaStopAutoplay();
      this.avalnaStartAutoplay();
    }
  };

  function avalnaInitHero() {
    var heroes = document.querySelectorAll('.avalna-hero');
    for (var i = 0; i < heroes.length; i++) {
      new AvalnaHeroCarousel(heroes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avalnaInitHero);
  } else {
    avalnaInitHero();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) {
      var hero = e.target.querySelector('.avalna-hero');
      if (hero) { new AvalnaHeroCarousel(hero); }
    });

    document.addEventListener('shopify:block:select', function(e) {
      var slide = e.target.closest('.avalna-hero__slide');
      if (!slide) return;
      var hero = slide.closest('.avalna-hero');
      if (!hero || !hero._avalnaHeroCarousel) return;
      var index = parseInt(slide.dataset.avalnaHeroSlideIndex, 10);
      hero._avalnaHeroCarousel.avalnaStopAutoplay();
      hero._avalnaHeroCarousel.avalnaGoTo(index);
    });

    document.addEventListener('shopify:block:deselect', function(e) {
      var hero = e.target.closest('.avalna-hero');
      if (!hero || !hero._avalnaHeroCarousel) return;
      var carousel = hero._avalnaHeroCarousel;
      if (carousel.autoplayEnabled && !carousel.reducedMotion.matches) {
        carousel.avalnaStartAutoplay();
      }
    });
  }
})();
